/* SPEC-489 — the password policy, mirrored client-side so the change-password form can
 * name a problem before it submits.
 *
 * THE SERVER IS THE AUTHORITY: `auth._validate_password` plus the 72-byte bcrypt ceiling in
 * `routes/account.py`. This copy only saves a round trip; a disagreement shows up as the
 * server's own message, never as a silently accepted password. */

export const MIN_LENGTH = 10;
export const MAX_BYTES = 72;

/** Problems with a proposed new password, in the order the server checks them. Empty = ok. */
export function passwordProblems(next: string, confirm: string, current = ''): string[] {
  const out: string[] = [];
  if (next.length < MIN_LENGTH) out.push(`Use at least ${MIN_LENGTH} characters.`);
  if (!/[A-Z]/.test(next)) out.push('Include at least one uppercase letter.');
  if (!/[0-9]/.test(next)) out.push('Include at least one number.');
  if (new TextEncoder().encode(next).length > MAX_BYTES) out.push(`Use ${MAX_BYTES} bytes at most.`);
  if (current && next === current) out.push('Choose a password different from the current one.');
  if (next !== confirm) out.push('The two new passwords do not match.');
  return out;
}
